<div class="card mt-6">
    <div class="flex justify-content-center">
        <p-card>
            <ng-template pTemplate="header">
                <div class="flex justify-content-between destacado">
                    <div class="flex">
                        <h2 class="ml-3 font-light">Login</h2>
                    </div>
                    <div class="flex md:hidden">
                        <img src="/assets/imagenes/logoCodelco.png"
                             alt="Logo codelco"
                             style="width: 195px; height: 39px;"
                             class="m-3">
                    </div>
                </div>
            </ng-template>
            <div class="flex flex-column"
                 style="min-width: 350px;">
                <div>
                    <form [formGroup]="form">
                        <div class="field">
                            <label for="rut">Rut</label>
                            <input type="text"
                                   class="inputfield w-full"
                                   name="rut"
                                   formControlName="rut"
                                   (blur)="formatearRut()"
                                   pInputText>
                            <div *ngIf="rut.invalid && (rut.dirty || rut.touched)">
                                <small *ngIf="rut.errors.required"
                                       class="p-error">
                                    Campo requerido
                                </small>
                                <small *ngIf="rut.errors.invalidRut"
                                       class="p-error">
                                    Rut inválido
                                </small>
                            </div>
                        </div>
                        <div class="field">
                            <label for="password">Contraseña</label>
                            <input type="password"
                                   name="password"
                                   class="inputfield w-full"
                                   formControlName="password"
                                   pInputText>
                            <div *ngIf="password.invalid && (password.dirty || password.touched)">
                                <small *ngIf="password.errors.required"
                                       class="p-error">
                                    Campo requerido
                                </small>
                            </div>
                        </div>
                    </form>
                    <div *ngIf="showError" class="flex justify-content-end mt-4 mb-0">
                        <span class="peligro">Rut o contraseña inválida</span>
                    </div>
                    <div class="flex justify-content-end mt-4 mb-0">
                        <button pButton
                                type="button"
                                label="Ingresar"
                                [disabled]="loading"
                                (click)="form.valid && login()"></button>
                    </div>
                </div>
            </div>
        </p-card>
    </div>
</div>
